import { SvgProps } from "../../types";

export default function TrashIcon({ stroke, width, height, strokeWidth }: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width || "16"}
            height={height || "16"}
            viewBox="0 0 24 24"
            fill="none"
            stroke={stroke || "#C92C3A"}
            strokeWidth={strokeWidth || "2"}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-trash-2"
        >
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            <line x1="10" y1="11" x2="10" y2="17" />
            <line x1="14" y1="11" x2="14" y2="17" />
        </svg>
    );
}
